import { Box, Button, Card, CardActions, CardContent, Stack, Typography } from "@mui/material";
import { Invoice } from "../../types/subscription";
import dayjs from "dayjs";
import DownloadIcon from "@mui/icons-material/Download";
import InvoiceStatusChip from "./InvoiceStatusChip";
import formatMoney from "../../utils/formatMoney";
import { useTranslation } from "react-i18next";

function InvoiceCard({ invoice, downloadInvoiceLinkMutation }: { invoice: Invoice; downloadInvoiceLinkMutation: any }) {
	const { t } = useTranslation();
	return (
		<Card key={invoice.id}>
			<CardContent>
				<Stack gap={"5px"}>
					<Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"}>
						<Box>
							<Typography variant="overline" lineHeight={1}>
								{t("invoicePage.invoice")} - {invoice.paymentMethod}
							</Typography>
							<Stack sx={{ display: "flex", flexDirection: "row" }}>
								<Typography sx={{ fontWeight: "medium", fontSize: 20, marginRight: "2px" }}>
									#
								</Typography>
								<Typography sx={{ fontWeight: "medium", fontSize: 20 }}>
									{invoice.invoiceNumber}
								</Typography>
							</Stack>
						</Box>
						<InvoiceStatusChip status={invoice.status} />
					</Stack>

					<Stack justifyContent={"space-between"} direction={"row"} pr={1}>
						<Typography variant="overline" fontSize="1rem" lineHeight={1.5}>
							{t("invoicePage.total")}:
						</Typography>
						<Typography>
							{invoice.currency.symbol}&nbsp;{formatMoney(invoice.total)}
						</Typography>
					</Stack>
					<Stack justifyContent={"space-between"} direction={"row"} pr={1}>
						<Typography variant="overline" fontSize="1rem" lineHeight={1.5}>
							{t("invoicePage.dueDate")}:
						</Typography>
						<Typography>{dayjs(invoice.dueDate).format("DD.MM.YY")}</Typography>
					</Stack>
				</Stack>
			</CardContent>
			<CardActions>
				<Button
					startIcon={<DownloadIcon />}
					onClick={() => downloadInvoiceLinkMutation.mutate(invoice.id)}
					disabled={downloadInvoiceLinkMutation.isLoading}
				>
					{downloadInvoiceLinkMutation.isLoading ? t("loading") : t("invoicePage.downloadPdf")}
				</Button>
			</CardActions>
		</Card>
	);
}

export default InvoiceCard;
